// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__34fHQ","footer":"ModalError_footer__1GxsR"};